import { TransactionStatusEnum } from './../../../models/transaction-status.enum';
import { TransactionService } from './../../../services/transactions/transaction.service';
import {
  ArrayUtilities,
  SortOrder,
} from './../../../shared/utilities/array-utilities';
import { ITransaction } from './../../../models/transaction';
// import { SaleCampaignService } from './../../services/sale-campaign/sale-campaign.service';
// import { StateContext } from '@ngxs/store';
// import { SaleCampaign } from './split-transaction.actions';
// import { Product } from './../../models/product';
// import { ISaleCampaign } from './../../models/sale-campaign';
import { Injectable, OnDestroy } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { BalanceModel, SplitTransactionStateModel } from './split-transaction.model';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable, Subscription, of } from 'rxjs';
import { SplitTransaction } from './split-transaction.actions';
import { number } from 'echarts';

@State<SplitTransactionStateModel>({
  name: 'SplitTransaction',
  defaults: {
    items: undefined,
    primaryTransaction: undefined,
    balances: undefined,
    selectedItem: undefined,
    splitTotal: undefined,
    remaining: undefined,
    count: 0,
    updateItem: undefined,
    deleteId: undefined,
    isLoading: false
  },
})
@Injectable()
export class SplitTransactionState implements OnDestroy {
  unSubscribeAll$ = new Subject<void>();
  constructor(
    private store: Store,
    // private campaignService: SaleCampaignService,
    private transactionService: TransactionService
  ) {}

  @Selector()
  static getSelectedTransaction(state: SplitTransactionStateModel): ITransaction {
    return state.selectedItem;
  }

  @Selector()
  static getBalanceAmounts(state: SplitTransactionStateModel): BalanceModel {
    return state.balances;
  }

  
  @Selector()
  static getTransactionList(state: SplitTransactionStateModel): ITransaction[] {
    return state.items;
  }

  @Selector()
  static getPrimaryTransaction(state: SplitTransactionStateModel): ITransaction {
    return state.primaryTransaction;
  }
  @Selector()
  static getSplitTransactionTotal(state: SplitTransactionStateModel): number {
    return state.splitTotal;
  }

  @Selector()
  static getRemainingAmount(state: SplitTransactionStateModel): number {
    return state.remaining;
  }

  @Selector()
  static getSplitTransactionCount(state: SplitTransactionStateModel): number {
    return state.count;
  }

  @Action(SplitTransaction.Actions.GetTransactions)
  getSplitTransactions(
    {patchState, getState, dispatch}: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.GetTransactions
  ) {
     return this.transactionService.getSplitTransactions(
            action.primaryTransactionId,
          )
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((splitTransactions) => {
        if(!splitTransactions) splitTransactions = [];
        const state = getState();
        const sortedTransactions = ArrayUtilities.sort(
          splitTransactions,
          'transactionDate',
          SortOrder.desc
        );
        patchState({
          items: [...sortedTransactions],
          count: sortedTransactions.length,
          isLoading: false,
        });
      
        dispatch(new SplitTransaction.Actions.GetBalances(state.primaryTransaction, sortedTransactions))
      });
  }

  @Action(SplitTransaction.Actions.SetPrimaryTransaction)
  setPrimaryTransaction(
    {patchState, getState, dispatch}: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.SetPrimaryTransaction
  ) {

        patchState({
          primaryTransaction: action.transaction,
          total: action.transaction.total
        });
      
        dispatch(new SplitTransaction.Actions.GetTransactions(action.transaction.id))
  }

  @Action(SplitTransaction.Actions.GetPrimaryTransaction)
  getPrimaryTransaction(
    ctx: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.GetPrimaryTransaction
  ) {
    const state = ctx.getState();
    const  selectedTransaction =  state.items.find(trax => trax.id === action.transactionId);
 

        ctx.patchState({
          selectedItem: selectedTransaction,
          isLoading: false,
        });
      };
  
  @Action(SplitTransaction.Actions.EditTransaction)
  editTransaction(
    ctx: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.EditTransaction
  ): Subscription {
    const state = ctx.getState();
    const  traxToUpdate = action.transaction;
    return this.transactionService.update(action.transaction.id, action.transaction)
    .pipe(takeUntil(this.unSubscribeAll$))
    .subscribe((trax) => {

        const currentItems = state.items;
        const updatedIndex = currentItems.findIndex((i) => i.id === trax.id);
        if (updatedIndex !== -1) {
          currentItems[updatedIndex] = trax;
          ctx.patchState ({
            selectedItem: trax,
            items: {...currentItems},
            isLoading: false
          })
          ctx.dispatch(new SplitTransaction.Actions.GetBalances(state.primaryTransaction, currentItems))
        }

       
    })
    
  }

  @Action(SplitTransaction.Actions.InsertSplitTransaction)
  insertTransaction(
    ctx: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.InsertSplitTransaction
  ) {
    return this.transactionService
      .create(action.transaction)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((transaction) => {
        const state = ctx.getState();
        let transactions = state.items;
        if (!transactions) transactions = [];
        const items  =[transaction, ...transactions];
        ctx.patchState({
          items: items,
          isLoading: false,
          selectedItem: transaction,
        });
        ctx.dispatch(new SplitTransaction.Actions.GetBalances(state.primaryTransaction, items))
      });
  }

  @Action(SplitTransaction.Actions.DeleteTransaction)
  deleteTranaction(
    {getState, patchState, dispatch}: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.DeleteTransaction
  ) {
  
    const transaction = { ...action.transaction };
    transaction.status = TransactionStatusEnum.Inactive;
    return this.transactionService
      .update(action.transaction.id, transaction)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((transaction) => {
        const state = getState();
        const transactions = [...state.items];
        const campaignIndex = transactions.findIndex((d) => d.id === transaction.id);

        if (campaignIndex >= 0) {
          transactions.splice(campaignIndex, 1);
        }

        patchState({
          items: [...transactions],
          updateItem: transaction,
          isLoading: false,
        });
        dispatch(new SplitTransaction.Actions.GetBalances(state.primaryTransaction, transactions))
      });
  }
  @Action(SplitTransaction.Actions.GetBalances)
  getBalances(
    {patchState, getState}: StateContext<SplitTransactionStateModel>,
    action: SplitTransaction.Actions.GetBalances
  ) {
      let total = action.primaryTransaction.amount;
      let splitTotal = 0;
      let remaining = 0;
    
      if(action.splitTransactions.length === 0) {
        total = action.primaryTransaction.amount;
        remaining = action.primaryTransaction.amount;          
      }  else {
      const splitTransactions = [...action.splitTransactions];
      splitTotal = splitTransactions.reduce((accumulator, item) => accumulator + item.amount, 0);    
      }
      const balance = { remaining: total-splitTotal, splitTotal: splitTotal, total: total} as BalanceModel;
        patchState({
          balances: balance,
          total: total,
          splitTotal: splitTotal,
          remaining:  total - splitTotal,
          isLoading: false,
        });
  }

  ngOnDestroy(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }
}
